.modal {
  max-width: initial !important;
}
.modal .modal-content {
  border: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk1vZGFsLnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTs7QUFDQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLm1vZGFsXG4gIG1heC13aWR0aDogaW5pdGlhbCAhaW1wb3J0YW50XG4gIC5tb2RhbC1jb250ZW50XG4gICAgYm9yZGVyOiBub25lXG4iXX0= */